





import {Component, Prop, Vue} from 'vue-property-decorator';

/**
 * @status stable
 * @published 4.8.0
 * @changelog 4.8.0 Published.
 * @changelog 4.8.3 Remove scope from styles, to support v-html'd data.
 * @changelog 4.9.0 Reset article styles to base, in case the parent adjusts anything.
 */
@Component
export default class JdsArticle extends Vue {
}
